module.exports = __webpack_public_path__ + "static/polarBear-da260ccff14ebba0017c8d28d3e66a60.jpg";